import { formatNumber } from '@progress/kendo-intl';
import { useCallback } from 'react';
import { viewAccrualColumns } from 'src/assets/static/accrual-report/useAccrualColumn';
import Button from 'src/components/design-system/Button';
import useViewAccrual from 'src/hooks/useViewAccrual';
import exportToExcel from 'src/utils/exportToExcel';
const Export = () => {
  const { t, accrualReport } = useViewAccrual();

  const handleExport = useCallback(() => {
    const columns: string[] = [];
    const columnMapping: Record<string, string> = {};

    const accrualColumns = [
      ...viewAccrualColumns.slice(0, 2),
      ...[
        { field: 'poNumber', title: 'PO' },
        { field: 'lineItemNumber', title: 'Line Item' },
      ],
      ...viewAccrualColumns.slice(2),
    ];

    accrualColumns.forEach((item) => {
      if (item.field !== '' && item.field !== 'expanded' && item.field !== 'link') {
        columns.push(item.field as string);
        Object.assign(columnMapping, { [item.field as string]: item.title });
      }
    });

    const rows: any[] = [];

    accrualReport.forEach((item) => {
      const parentRow = {
        ...item,
        poTotal: formatNumber(item.poTotal, 'c2'),
        amountInPeriod: formatNumber(item.amountInPeriod, 'c2'),
        accrualAmount: formatNumber(item.accrualAmount, 'c2'),
      };

      rows.push(parentRow);

      if (item.pos && Array.isArray(item.pos)) {
        item.pos.forEach((childPos) => {
          const childRow = {
            ...childPos,
            glCd: '',
            poTotal: formatNumber(childPos.poTotal, 'c2'),
            amountInPeriod: formatNumber(childPos.amountInPeriod, 'c2'),
            accrualAmount: formatNumber(childPos.accrualAmount, 'c2'),
            supplierName: childPos.supplierName,
          };
          rows.push(childRow);

          if (childPos.lineItems && Array.isArray(childPos.lineItems)) {
            childPos.lineItems.forEach((lineItem) => {
              const lineItemRow = {
                ...lineItem,
                poTotal: formatNumber(lineItem.poTotal, 'c2'),
                amountInPeriod: formatNumber(lineItem.amountInPeriod, 'c2'),
                accrualAmount: formatNumber(lineItem.accrualAmount, 'c2'),
                parentSupplierName: lineItem.supplierName,
                poNumber: '',
                glCd: '',
              };
              rows.push(lineItemRow);
            });
          }
        });
      }
    });

    exportToExcel({
      columns,
      rows,
      columnMapping,
      fileName: 'Accrual Report Excel Sheet',
    });
  }, [accrualReport]);

  return (
    <Button color="secondary" onClick={handleExport}>
      {t('Export')}
    </Button>
  );
};

export default Export;
